import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AccessPage } from './pages/AccessPage';
import { Dashboard } from './pages/Dashboard';
import { Profile } from './pages/Profile';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<AccessPage data-id="element-3" />} data-id="element-2" />
        <Route path="/betiq-dashboard" element={<Dashboard data-id="element-5" />} data-id="element-4" />
        <Route path="/profile" element={<Profile data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}